import { SSO_CALLBACK_PATH } from "src/modules/common/services/sso/ssoCallbackPath";

export const shouldEnterSsoCallback = (pathname: string): boolean =>
    normalisePathname(pathname) === SSO_CALLBACK_PATH;

export const clearSsoCallbackResponseFromUrl = (): void => {
    if (!window.location.search && !window.location.hash) {
        return;
    }

    window.history.replaceState(window.history.state, document.title, window.location.pathname);
};

const normalisePathname = (pathname: string): string => {
    if (pathname.length > 1 && pathname.endsWith("/")) {
        return pathname.slice(0, -1);
    }

    return pathname;
};
